'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var SocialTelegram = /*#__PURE__*/ forwardRef(function(props, ref) {
    return /*#__PURE__*/ jsx(SvgIcon, _extends({
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props, {
        ref: ref,
        children: /*#__PURE__*/ jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M15.652 1.953a.66.66 0 0 0-.9-.71L.633 6.965C.056 7.2.095 8.03.692 8.209L4 9.202l1.521 4.945a.5.5 0 0 0 .84.198l2.102-2.102 4.25 2.833a.66.66 0 0 0 1.018-.45zM5.2 8.913l5.714-3.334L6.61 9.882a1.3 1.3 0 0 0-.35.637l-.339 1.527-.857-2.786a.3.3 0 0 1 .135-.348",
            clipRule: "evenodd"
        })
    }));
});
SocialTelegram.displayName = "SocialTelegram";

export { SocialTelegram, SocialTelegram as default };
